import ContentManagement from './ContentManagement';

export default ContentManagement;
